import { Page } from '@/components/page/Page'
import HomePdf from '@/homes/9115-tudor-e106/9115Tudor_Synopsis.pdf'
import { data, seo } from '@/homes/9115-tudor-e106/info'
import { HomeDetailsTable } from '@/components/homes/HomeDetailsTable'
import { homeAddressStr } from '@/helpers/homes'
import SEO from '@/utils/SEO'
import { PDFHome } from '@/components/homes/PDFHome'
import { YoutubeEmbed } from '@/components/misc/YoutubeEmbed'
import { VerticalMargin } from '@/styles/page'

export const Home9115TudorE106 = () => {
  return (
    <Page>
      <SEO {...seo} />

      <h1>{homeAddressStr(data)}</h1>
      <VerticalMargin>
        <YoutubeEmbed embedId="TnfpjQVKt7I" />
      </VerticalMargin>

      <HomeDetailsTable data={data} />

      <hr />
      <br />
      <br />

      <h1>Waterfront Condo in Tudor Cay</h1>
      <h2>Updated Interiors • Canal Views • Resort-Style Amenities</h2>

      <p>
        Enjoy peaceful waterfront living in this beautifully renovated 1-bedroom condo located
        in the highly desirable Tudor Cay community in Tampa. This bright and modern home
        features 760 sq. ft. of updated living space, a private screened lanai overlooking the
        canal, and convenient access to Tampa’s top beaches, restaurants, and Tampa
        International Airport.
      </p>

      <p>
        Step through the sliding glass doors from the bedroom and unwind on your private
        screened lanai while enjoying serene views of Rocky Creek. Inside, the home features
        all-new stainless steel appliances, updated cabinets and countertops, fully renovated
        bathroom with modern finishes, fresh paint, new flooring, and generous closet space.
      </p>

      <h2>Interior Features:</h2>
      <ul>
        <li>Beautifully renovated 1-bedroom, 1-bath layout</li>
        <li>New stainless steel appliances throughout the kitchen</li>
        <li>Updated cabinets, countertops, and fixtures</li>
        <li>Fully remodeled bathroom with new tile and vanity</li>
        <li>Fresh interior paint and new flooring</li>
        <li>Walk-in closet in primary bedroom</li>
        <li>Sliding glass doors leading to private screened lanai</li>
      </ul>

      <h2>Community Amenities:</h2>
      <ul>
        <li>Two sparkling community pools</li>
        <li>Tennis, basketball, handball & racquetball courts</li>
        <li>Boat parking available</li>
        <li>Fishing dock along the canal</li>
        <li>Clubhouse and on-site laundry facilities</li>
        <li>Waterfront paths and serene canal views</li>
      </ul>

      <h2>Additional Highlights:</h2>
      <ul>
        <li>New water heater (2025)</li>
        <li>Pet-friendly community</li>
        <li>Assigned, boat, guest, and open parking</li>
        <li>Low-maintenance lifestyle with includes water & sewer</li>
        <li>Just 6 miles from Tampa International Airport</li>
        <li>Minutes to beaches, dining, and shopping</li>
      </ul>

      <p>
        Whether you're searching for a full-time residence, seasonal getaway, or investment
        property, this updated condo offers the perfect blend of comfort, convenience, and
        waterfront living in one of Tampa’s most accessible locations.
      </p>

      <p>
        <strong>Schedule your private showing today and experience waterfront living at Tudor Cay!</strong>
      </p>

      <br />
      <h3>Call me today for more information (805) 765-1625</h3>

      <PDFHome src={HomePdf} data={data} />
    </Page>
  )
}
